<div class="flex flex-col flex-col-reverse md:flex-row md:gap-8">
    <div class="md:w-[30%] w-full">
        <p class="md:text-3xl text-xl md:mb-12 mb-8 text-center mt-4">
            Welcome to our Partner Portal
        </p>
        <app-load-spinner-wrapper [loading]="loading">
            <p class="md:text:xl text-lg mb-2">Password Expired</p>
            <p class="text-sm mb-2">For your security, your password has expired. Please reset it to continue accessing the Partner Portal.</p>
            <button
                mat-raised-button
                class="mt-4 !bg-green w-full mb-8"
                (click)="onResetPassword()">
                <p class="md:text-lg text-base">Reset Password</p>
            </button>
            <a [routerLink]="['/portal-login']" class="underline">Back</a>
        </app-load-spinner-wrapper>
    </div>
    <div class="md:w-[70%] w-full">
        <img
            src="assets/images/partnerPortalLoginImage.png"
            alt="Partner Portal"
            class="w-full h-auto">
    </div>
</div>
